<template lang="pug">
  .checkout
    .header(class="z-1")
      .header__content
        a(:href="linkHome")
          img(src='~@/assets/paguemenos.png' alt="Logo Pague Menos"  height="62")
    .container(:class="{ 'container--mobile': !hasDesk, 'container--no-padding-top': showGoBackButton }")

      .details-buy(v-if="showGoBackButton")
        a.details-buy__back-btn(v-if="previousPage" :href="previousPage")
          img.details-buy__back-icon(src="~@/assets/icons/back-arrow.svg")
          span Voltar
        button.details-buy__back-btn(v-else-if="hasHistory" @click="goBack")
          img.details-buy__back-icon(src="~@/assets/icons/back-arrow.svg")
          span Voltar

      .container__mainTitle
        .content
          template(v-if="isBreadcrumbs")
            cp-breadcrumbs
          template(v-else-if="hasDesk && !isBreadcrumbs")
            h2.checkout__title {{ lblTitle }}
            p.checkout__subtitle {{ lblSubTitle }}
        cp-button.btnDetailsBuy(
          theme="outlined"
          size="medium"
          :label="lblDetailsBuy"
          @onClick="openModal"
        )

      cp-desk(v-if="hasDesk")
      cp-mobile(v-else @openModal="openModal")

      .modal(v-if="showModal" class="z-999")
        .modal__background
          .modal__container(class="z-1")
            .modal__header
              .modal__close(class="z-1" @click="closeModal") Fechar
            .modal__content
              cp-info-payment(v-if="!configApp.isEmployee")
              cp-info-insurance
</template>
<script>
import { mapState } from 'vuex'

import cpBreadcrumbs from '@/components/molecules/Breadcrumbs.vue'
import cpButton from '@/components/atoms/Button.vue'
import cpDesk from '@/templates/Desk.vue'
import cpInfoPayment from '@/components/organisms/InfoPayment.vue'
import cpInfoInsurance from '@/components/organisms/InfoInsurance.vue'
import cpMobile from '@/templates/Mobile.vue'
export default {
  name: 'Checkout',
  data () {
    return {
      detailButtonLabelList: {
        checkout: 'Resumo da compra',
        funcionario: 'Resumo'
      },
      hasDesk: '',
      showModal: false
    }
  },
  components: {
    cpBreadcrumbs,
    cpButton,
    cpDesk,
    cpInfoPayment,
    cpInfoInsurance,
    cpMobile
  },
  created () {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)

    const self = this
    this.$root.$on('openModal', function (shouldOpenPromoCodeForm) {
      self.openModal()

      if (shouldOpenPromoCodeForm) {
        self.$nextTick(() => self.$root.$emit('openPromoCodeForm'))
      }
    })
    this.$root.$on('openDetailsModal', function () {
      self.openDetailsModal()
    })
  },
  computed: {
    ...mapState(['configApp']),
    ...mapState('product', ['isRenovation', 'previousPage', 'alias']),
    linkHome () {
      return process.env.VUE_APP_URL_HOME
    },
    lblTitle () {
      if (/bolsa-protegida/.test(this.alias)) {
        return 'Finalize seu cadastro'
      }

      return this.isRenovation
        ? 'Finalizar renovação'
        : 'Complete seu cadastro'
    },
    lblSubTitle () {
      if (/bolsa-protegida/.test(this.alias)) {
        return 'Preencha os dados restantes pra concluir a contratação'
      }

      return this.isRenovation
        ? 'Para finalizar sua renovação, preencha os dados abaixo.'
        : 'Para finalizar sua compra, preencha os dados abaixo.'
    },
    lblDetailsBuy () {
      return this.detailButtonLabelList[process.env.VUE_APP_JOURNEY_NAME]
    },
    isBreadcrumbs () {
      return this.hasDesk && this.alias && /saude|pet/.test(this.alias)
    },
    hasHistory () {
      return window.history.length > 1
    },
    showGoBackButton () {
      return (this.hasHistory || this.previousPage)
    }
  },
  methods: {
    handleResize () {
      this.hasDesk = window.innerWidth > 767 && true
    },
    openModal () {
      this.showModal = true
      document.body.style.overflow = 'hidden'
    },
    closeModal () {
      this.showModal = false
      document.body.removeAttribute('style')
    },
    goBack () {
      this.$router.go(-1)
    }
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
<style lang="scss" scoped>
  @import "@/assets/style/_variables";

  .header {
    background-color: #ffffff;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.03);
    height: 82px;
    position: relative;
    width: 100%;

    &__content {
      align-items: center;
      display: flex;
      justify-content: center;
      height: 100%;
      margin: 0 auto;
      max-width: 1313px;
      padding-left: 16px;
      width: 100%;

      @media screen and (min-width: 840px) and (max-width: 1366px) {
        padding-left: 80px;
      }
    }
  }

  .checkout {
    &__subtitle {
      font-family: $rubik-font-family;
    }

    .container {
      margin: 0 auto;
      max-width: 1313px;
      padding: 56px 16px 0 16px;

      @media screen and (min-width: 840px) and (max-width: 1366px) {
        padding-left: 80px;
        padding-right: 80px;
      }

      &--mobile {
        padding: 0;
      }

      &--no-padding-top {
        padding-top: 0;
      }

      .checkout__title {
        font-size: 32px;
        font-weight: bold;
        color: #444444;
      }

      .checkout__subtitle {
        color: #595959;
        font-family: $rubik-font-family;
        font-size: 16px;
        margin-bottom: 24px;
        margin-top: 6px;
      }
    }
  }

  .details-buy {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-top: 19px;
    padding-bottom: 19px;
    width: 100%;

    @media screen and (max-width: 767px) {
      padding-left: 16px;
      padding-right: 16px;
    }

    &__back-btn {
      align-items: center;
      display: flex;
      font-family: $oscine-font-family;
      font-size: 16px;
      font-weight: 700;
      color: #636D7A;
      margin-right: 16px;
      margin-bottom: 16px;
      cursor: pointer;
    }

    &__back-icon {
      margin-right: 16px;
    }
  }

  .container__mainTitle {
    @media screen and (min-width: 768px) and (max-width: 1279px) {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

  .btnDetailsBuy {
    display: none;

    @media screen and (min-width: 768px) and (max-width: 1279px) {
      display: inline-block;
      margin-bottom: 24px;
      max-width: 211px;
    }
  }

  .modal {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;

    &__background {
      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      height: 100vh;
      overflow: auto;
      position: fixed;
      width: 100%;
    }

    &__container {
      background-color: #fff;
      border-radius: 8px;
      display: block;
      max-width: 450px;
      position: relative;
      text-align: left;
      width: 100%;

      @media screen and (min-width: 426px) {
        margin: auto;
      }
    }

    &__close {
      background: url("~@/assets/icons/close.svg") no-repeat center center;
      cursor: pointer;
      height: 24px;
      position: absolute;
      top: 40px;
      right: 32px;
      overflow: hidden;
      text-indent: 101%;
      white-space: nowrap;
      width: 24px;
    }

    &__title {
      margin: 0;
      width: 85%;
    }
  }
</style>
